import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
import { formatNumber } from '@/components/cost-explorer/utils/numberUtils';
import { fileSizeFormatter } from '@/utils/fileSizeFormatter';
import { pluralize } from '@/utils/string';
interface PaginationTitleProps {
  // Singular form of the entity (e.g. "rule", "policy"). It is pluralized
  // based on the count via `pluralize`, so a count of 1 stays singular.
  entityLabel: string;
  selection?: {
    isAllSelected?: boolean;
    selectedRecordsCount?: number;
  };
  isLoading: boolean;
  recordsCount: number;
  totalSourceStorageSizeBytes?: number;
  // Renders verbatim in place of the recordsCount-driven "N found" text, for
  // tables with no total (e.g. cursor-paginated listings) that still want a
  // real row range on the left. Selection-mode text always takes priority.
  titleOverride?: string;
}
export function PaginationTitle(props) {
  const $ = _c(16);
  const {
    entityLabel,
    selection,
    isLoading,
    recordsCount,
    titleOverride
  } = props;
  let t0;
  if ($[0] !== selection) {
    t0 = selection ?? {};
    $[0] = selection;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    selectedRecordsCount,
    isAllSelected
  } = t0;
  let title = "";
  if (isLoading) {
    title = "Loading...";
  }
  if (!isLoading) {
    if (selectedRecordsCount && selectedRecordsCount > 0) {
      let t1;
      if ($[2] !== entityLabel || $[3] !== isAllSelected || $[4] !== selectedRecordsCount) {
        t1 = isAllSelected ? `All ${selectedRecordsCount} ${pluralize(entityLabel, selectedRecordsCount)} on this page ${selectedRecordsCount === 1 ? "is" : "are"} selected` : `${selectedRecordsCount} ${pluralize(entityLabel, selectedRecordsCount)} selected on this page`;
        $[2] = entityLabel;
        $[3] = isAllSelected;
        $[4] = selectedRecordsCount;
        $[5] = t1;
      } else {
        t1 = $[5];
      }
      title = t1;
    } else {
      if (titleOverride) {
        title = titleOverride;
      } else {
        if (recordsCount > -1) {
          const t1 = recordsCount ?? 0;
          let t2;
          if ($[6] !== t1) {
            t2 = formatNumber(t1, 0);
            $[6] = t1;
            $[7] = t2;
          } else {
            t2 = $[7];
          }
          let t3;
          if ($[8] !== entityLabel || $[9] !== recordsCount) {
            t3 = pluralize(entityLabel, recordsCount);
            $[8] = entityLabel;
            $[9] = recordsCount;
            $[10] = t3;
          } else {
            t3 = $[10];
          }
          title = `${t2} ${t3} found`;
          if (props.totalSourceStorageSizeBytes !== undefined) {
            const t4 = title;
            let t5;
            if ($[11] !== props.totalSourceStorageSizeBytes) {
              t5 = fileSizeFormatter(props.totalSourceStorageSizeBytes, 1, false);
              $[11] = props.totalSourceStorageSizeBytes;
              $[12] = t5;
            } else {
              t5 = $[12];
            }
            title = t4 + ` (${t5})`;
          }
        }
      }
    }
  }
  let t1;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      color: "var(--mui-palette-text-primary)",
      lineHeight: "24px"
    };
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== title) {
    t2 = <Typography data-testid="pagination-title" component="span" sx={t1}>{title}</Typography>;
    $[14] = title;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
}